import { Button, Dialog, DialogContent, DialogTitle, Grid, Typography } from '@mui/material';
import { EconsultCancelButton } from '@oh-vcp/components-ui';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface EconsultSpecialistDraftWarningDialogProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const EconsultSpecialistDraftWarningDialog: FC<EconsultSpecialistDraftWarningDialogProps> = ({
  isOpen,
  onConfirm,
  onCancel
}) => {
  const { t } = useTranslation();
  return (
    <Dialog open={isOpen}>
      <DialogTitle>
        <Typography variant="h3" color="base.grey3">
          {t('Case.consult.warning')}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" color="base.grey3">
          {t('Case.consult.specialistDraftNoteWillBeDeleted')}
        </Typography>
        <Typography variant="body1" color="base.grey3">
          {t('Case.consult.specialistDraftNoteWillBeDeleted2')}
        </Typography>
        <Grid container item xs={12} justifyContent="flex-end" pt={3}>
          <Button variant="contained" color="primary" sx={{ mr: 1 }} onClick={onConfirm}>
            {t('Case.button.confirm')}
          </Button>
          <EconsultCancelButton variant="contained" onClick={onCancel}>
            {t('Case.button.cancel')}
          </EconsultCancelButton>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default EconsultSpecialistDraftWarningDialog;
